// extracted by mini-css-extract-plugin
export default {"loader":"Spinere_loader__Jqlfd","spin89345":"Spinere_spin89345__cPas8"};